import { InstrumentBookFullDto } from '@/gen/marketDataApi'

import { Card } from '@/components/card'
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/table/index.tsx'

import DepthPricePoints from './depthPricePoints.tsx'

interface Props {
    bids: Array<InstrumentBookFullDto['bids'][0] & { quantity: number }>
    largestQuantity: number
    otherSideCount: number
}

export default function Bids({ bids, largestQuantity, otherSideCount }: Props) {
    return (
        <Card hideOverflow>
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead className="text-right">Orders</TableHead>
                        <TableHead className="text-right">Quantity</TableHead>
                        <TableHead className="text-right">Bid</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    <DepthPricePoints
                        bidOrAsk="bid"
                        points={bids}
                        largestQuantity={largestQuantity}
                        otherSideCount={otherSideCount}
                    />
                </TableBody>
            </Table>
        </Card>
    )
}
